const modelModal = {
  showModal: false,
  routeRedirection: '',
  title: '',
  message: '',
  textButton: '',
};

export default { modelModal };
